import { ExternalLink } from '@music-vine/cadence/icons';
export const LUTS_TUTORIAL_URL = 'https://uppbeat.io/blog/motion-graphics/color-grading/what-is-a-lut#how-to-use-luts-in-different-video-editing-software';
export const LutsTipsBanner = () => <div className="flex flex-col items-center gap-3 rounded-lg border border-gray-150 bg-gray-50 px-4 py-3 text-center sm:flex-row sm:justify-between sm:gap-4 sm:text-left dark:border-gray-800 dark:bg-gray-900" data-sentry-component="LutsTipsBanner" data-sentry-source-file="LutsTipsBanner.tsx">
    <div className="flex flex-col">
      <span className="font-semibold text-base text-gray-950 dark:text-white">
        New to LUTs?
      </span>
      <span className="text-gray-700 text-sm dark:text-gray-200">
        A step-by-step guide to applying them to your footage.
      </span>
    </div>
    <a className="inline-flex items-center gap-1 text-inline-link text-sm underline hover:text-brand-primary-active dark:text-white" href={LUTS_TUTORIAL_URL} rel="noopener" target="_blank">
      How to use LUTs
      <ExternalLink className="size-4" data-sentry-element="ExternalLink" data-sentry-source-file="LutsTipsBanner.tsx" />
    </a>
  </div>;